import Nullstack from 'nullstack';
export default function IconBoxAlignTop({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-box-align-top",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M4 9.505h16v-5a1 1 0 0 0 -1 -1h-14a1 1 0 0 0 -1 1v5z"
  }), "   ", Nullstack.element("path", {
    d: "M4 14.505v-.01"
  }), "   ", Nullstack.element("path", {
    d: "M4 19.505v-.01"
  }), "   ", Nullstack.element("path", {
    d: "M9 19.505v-.01"
  }), "   ", Nullstack.element("path", {
    d: "M15 19.505v-.01"
  }), "   ", Nullstack.element("path", {
    d: "M20 19.505v-.01"
  }), "   ", Nullstack.element("path", {
    d: "M20 14.505v-.01"
  }), " ");
}